import { render, staticRenderFns } from "./OperaCouponGoodsWindow.vue?vue&type=template&id=e2651146&scoped=true&"
import script from "./OperaCouponGoodsWindow.vue?vue&type=script&lang=js&"
export * from "./OperaCouponGoodsWindow.vue?vue&type=script&lang=js&"
import style0 from "./OperaCouponGoodsWindow.vue?vue&type=style&index=0&id=e2651146&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2651146",
  null
  
)

export default component.exports